import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Controller } from "react-hook-form";
import { DatePicker } from "@libs/rubick";
import { MessageBox } from "./MessageBox";
import { DateInputValueFormat, formatDateInput, parseDateInput } from "@/utils/date";
export function FormDatePicker({ name, control, label, placeholder = "Pick a date", disabled = false, errors, valueFormat = DateInputValueFormat.DateOnly }) {
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            label && /*#__PURE__*/ _jsx("label", {
                className: "block font-bold mb-2 text-sm text-gray-700 mt-0",
                children: label
            }),
            /*#__PURE__*/ _jsx(Controller, {
                name: name,
                control: control,
                render: ({ field })=>{
                    const handleDateChange = (date)=>{
                        if (!date) {
                            field.onChange("");
                            return;
                        }
                        field.onChange(formatDateInput(date, valueFormat));
                    };
                    return /*#__PURE__*/ _jsx(DatePicker, {
                        date: parseDateInput(field.value),
                        onDateChange: handleDateChange,
                        placeholder: placeholder,
                        disabled: disabled
                    });
                }
            }),
            errors?.message && /*#__PURE__*/ _jsx(MessageBox, {
                className: "px-4 py-2 mb-6",
                message: errors.message,
                type: "error"
            })
        ]
    });
}
